import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { confirmation } from 'redux-form-validators';
import {
    FormComponent,
    PasswordInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';

import { passwordResetCommit } from '../../../services/authentication/resetpassword/actions';
import { withTemplate } from '../../template/withTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import HeadComponent from '../../HeadComponent';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';

class PasswordResetCommitFormComponent extends React.Component {
    handleSubmit = data => {
        this.props.passwordResetCommit(
            data,
            this.props.match.params.email,
            this.props.match.params.token
        );
    };

    renderForm = () => {
        const { i18n, requestSubmit, successSubmit, errorSubmit, errorMessage } = this.props;
        if (!successSubmit) {
            return (
                <FormComponent
                    form="password-reset-commit-form"
                    onSubmit={this.handleSubmit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}>
                    <PasswordInputFieldComponent
                        name="password"
                        placeholder={i18n.form.placeholder.PASSWORD}
                        isRequired
                        validate={[confirmation({ field: 'confirmation', msg: ' ' })]}
                    />
                    <PasswordInputFieldComponent
                        name="confirmation"
                        placeholder={i18n.form.placeholder.PASSWORD_CONFIRM}
                        isRequired
                        validate={[
                            confirmation({
                                field: 'password',
                                msg: i18n.form.PASSWORD_CONFIRM_ERROR
                            })
                        ]}
                    />
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                    <LegendFieldComponent classNameInputContainer="small">
                        {i18n.MSG_BOTTOM}
                    </LegendFieldComponent>
                </FormComponent>
            );
        }
    };

    renderMessageSubmit = () => {
        const { successSubmit, i18n } = this.props;
        if (successSubmit) {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.form.SUCESS_MESSAGE}</p>
                </SuccessInfoComponent>
            );
        }
    };

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to="/password-reset/:email/:token">
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                {this.renderForm()}
                {this.renderMessageSubmit()}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.PASSWORDRESET.COMMIT,
        errorMessage: state.authentication.resetpassword.error || '',
        requestSubmit: state.authentication.resetpassword.fetching || false,
        successSubmit: state.authentication.resetpassword.successPasswordResetCommit || false,
        errorSubmit: !_.isEmpty(state.authentication.resetpassword.error)
    };
};

const mapDispatchToProps = {
    passwordResetCommit
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(PasswordResetCommitFormComponent),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/resetpassword/PasswordResetCommitFormComponent.js